import React, { lazy, Suspense } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { HelmetProvider } from 'react-helmet-async';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';

import { RemoteConfigContext } from './remoteConfigContext';
import { reactPlugin } from './ApplicationInsights';

const App = lazy(() => import('./views/containers/App'));

// Keeping the fallback empty, so that the css loader will be shown
const ConnectedApp = ({ store }) => {
  const strictModeEnabled =
    process.env.NODE_ENV !== 'production' &&
    import.meta.env.VITE_ENABLE_STRICT_MODE === 'true';
  const AppContent = () => (
    <AppInsightsContext.Provider value={reactPlugin}>
      <Suspense fallback={<></>}>
        <App />
      </Suspense>
    </AppInsightsContext.Provider>
  );

  const content = strictModeEnabled ? (
    <React.StrictMode>
      <AppContent />
    </React.StrictMode>
  ) : (
    <AppContent />
  );

  return (
    <Provider store={store}>
      <HelmetProvider>
        <RemoteConfigContext.Provider>{content}</RemoteConfigContext.Provider>
      </HelmetProvider>
    </Provider>
  );
};

ConnectedApp.propTypes = {
  store: PropTypes.object,
};

export default ConnectedApp;
